export default {
    GET_ALL_WAREHOUSE: 'GET_ALL_WAREHOUSE',
    ADD_WAREHOUSE: 'ADD_WAREHOUSE',
    UPDATE_WAREHOUSE: 'UPDATE_WAREHOUSE',
    DELETE_WAREHOUSE: 'DELETE_WAREHOUSE',
    CHANGE_ACTIVATION: 'CHANGE_ACTIVATION',
}